define('OutSystems/ReactView/Portal',["require", "exports", "tslib", "react", "react-dom", "./HtmlTags"], function (require, exports, tslib_1, React, ReactDOM, HtmlTags_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Portal = void 0;
    var Portal = (function (_super) {
        tslib_1.__extends(Portal, _super);
        function Portal(props) {
            var _this = _super.call(this, props) || this;
            _this.portalContainer = document.createElement("div");
            _this.portalContainer.style.display = "inline";
            _this.portalContainer.className = Portal.PortalClassName;
            document.body.appendChild(_this.portalContainer);
            return _this;
        }
        Portal.prototype.componentWillUnmount = function () {
            var _this = this;
            setTimeout(function () { return document.body.removeChild(_this.portalContainer); });
        };
        Portal.prototype.render = function () {
            return ReactDOM.createPortal(React.createElement(HtmlTags_1.HtmlTags.div, { context: this.context }, this.props.children), this.portalContainer);
        };
        Portal.PortalClassName = "portal-class";
        return Portal;
    }(React.Component));
    exports.Portal = Portal;
});
//# sourceMappingURL=Portal.js.map;
